import { call, put, select } from 'redux-saga/effects';
import { ChangeScheduleAction } from '../../../../ts/services/ChangeScheduleAction';

import { Messages } from '../../../../codegen/Localize';
import { RefreshPropertyHelper } from '../../../../ts/helpers/RefreshPropertyHelper';
import { IDataSourceBase } from '../../../../ts/models/IDataSourceInfo';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { EditRemoteRefreshScheduleAction } from '../../../../ts/services/EditRemoteRefreshScheduleAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeRemoteExtractRefreshAction } from '../../../actions/spaces/ChangeRemoteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { selectSpaceInfoItem } from '../../../selectors/ContentSelectors';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleChangeRemoteExtractRefreshAction(action: ChangeRemoteExtractRefreshAction) {
  try {
    const datasource: IDataSourceBase = yield select(selectSpaceInfoItem);
    yield call(executeChangeRemoteExtractRefreshAction, datasource, action.schedule);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeRemoteExtractRefreshAction(
  datasource: IDataSourceBase,
  item: IRemoteRefreshScheduleInfo
) {
  const editRemoteExtractRefreshService =
    ServiceLocator.get<EditRemoteRefreshScheduleAction>('EditRemoteRefreshScheduleAction');
  const changeScheduleService = ServiceLocator.get<ChangeScheduleAction>('ChangeScheduleAction');
  const context = ServiceLocator.getAngularActionContext();
  const availableTypes = RefreshPropertyHelper.getAvailableRefreshTypes(datasource);
  return editRemoteExtractRefreshService.execute(context, datasource, item, availableTypes, changeScheduleService);
}
